import React, { useState, useEffect, useContext, useRef } from 'react';
import { Modal, Table } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import ReactToPrint from 'react-to-print';
import { DataContext } from '../../../init/getData';
import { FcPortraitMode, FcAbout, FcInTransit, FcHome } from "react-icons/fc";
import Loader from '../../../components/loader/loader';
import { datePrintFormatter } from '../../../dynamic/dateFormatter';
import { print } from "../../../dynamic/print";

import { Button, Card } from 'antd';




const AccountStatementReport = (props) => {

  const { api, userData, settingData, serverApi, localApi, devData } = useContext(DataContext);


  const { showModal, toggleModal, idRow, report, reportRef, filter, selectedAccount,
    selectedCurrency, mainCurrency, secondaryCurrency, currency } = props;

  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;
  const statementReportRef = useRef(null);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (showModal) {
      fetchData();
    }
  }, [showModal]);


  const fetchData = async () => {
    try {
      setIsLoading(true);

      const data = {
        filter,
      }
      const response = await api.get(`/accountStatement/getAll`, { params: data });
      if (response) {
        const data = response?.data?.data;
        setData(data);
      }

      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };


  return (
    <Modal show={showModal} backdrop="static" size='xl' onHide={toggleModal}>
      <Modal.Header style={{ background: "#39aaa5", display: "flex", justifyContent: "center" }}>
        <div>
          <Modal.Title style={{ color: "white" }}> Report </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>

        {isLoading &&
          <Loader />
        }


        {!isLoading &&
          <Card ref={statementReportRef}>
            {/* Title */}
            <div style={{ textAlign: 'center', fontSize: 20, fontWeight: 'bold', color: '#000', marginBottom: 16 }}>
              STATEMENT OF ACCOUNT
            </div>

            {/* Header Information */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24, fontSize: 14 }}>
              <div><strong>Period:</strong> {filter.fromDate} to {filter.toDate}</div>
              <div><strong>Account:</strong> {selectedAccount?.label || 'All Accounts'}</div>
              <div>
                <strong>Currency:</strong>{' '}
                {currency === 'main' && mainCurrency?.code}
                {currency === 'secondary' && secondaryCurrency?.code}
              </div>
            </div>

            {/* Table */}
            <Table style={{ width: '100%' }} bordered hover>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Account</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Payment</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Balance</th>
                </tr>
              </thead>

              <tbody>

                {data?.map(item => (
                  <tr key={item.id}>
                    <td>{item?.journalVoucherId}</td>
                     <td>{item?.journalVoucher?.account?.english}</td>
                    <td>{item?.journalVoucher?.date}</td>
                    <td>{item?.journalVoucher?.type}</td>
                    <td>{item?.journalVoucher?.paymentType}</td>
                    {currency == 'main' &&
                      <>
                        <td>{numberFormatter(item?.totalDebit)}</td>
                        <td>{numberFormatter(item?.totalCredit)}</td>
                        <td>{numberFormatter(item?.cumulativeBalance)}</td>
                      </>
                    }
                    {currency == 'secondary' &&
                      <>
                        <td>{numberFormatter(item?.secondaryTotalDebit)}</td>
                        <td>{numberFormatter(item?.secondaryTotalCredit)}</td>
                        <td>{numberFormatter(item?.secondaryCumulativeBalance)}</td>
                      </>
                    }
                  </tr>
                ))}


                <tr style={{ fontWeight: 'bold' }}>
                  <td colSpan="5"></td>
                  <td>Total</td>

                  <td style={{ textAlign: 'right' }}>
                    <>
                      {numberFormatter((data?.[data?.length - 1]?.cumulativeBalance || 0)) + mainCurrency?.code}
                      <br />
                      {numberFormatter((data?.[data?.length - 1]?.secondaryCumulativeBalance || 0)) + ' ' + secondaryCurrency?.code}

                    </>
                  </td>


                </tr>

              </tbody>
            </Table>

            {/* Footer */}
            <div style={{ marginTop: 24, textAlign: 'right', fontSize: 12, color: '#000', padding: '10px 0' }}>
              Generated on: {new Date().toLocaleDateString()} by {userData.name}
            </div>
          </Card>
        }
      </Modal.Body>

      <div className="modal-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="button" className="btn btn-secondary" style={{ backgroundColor: '#1f2937' }} onClick={toggleModal}>Close</button>

          <ReactToPrint 
            trigger={() => <button type="button" style={{ backgroundColor: '#1d7790' }} className="btn btn-primary">Print</button>}
            content={() => statementReportRef.current} 
          />
        </div>
      </div>

    </Modal>
  );
};

export default AccountStatementReport;
